module.exports = __webpack_public_path__ + "img/document_icon.543e0030.svg";